import { createReducer } from '@reduxjs/toolkit';
import * as actions from './actions';
import { AppState } from '../../global/types';
import { SettingsPagePharmacyState } from './types';

const initialState: SettingsPagePharmacyState = {
  glovoEnabledPharmacyStatus: {
    data: {
      status: null,
    },
    loading: false,
    error: null,
  },
};

const reducer = createReducer(initialState, {
  [actions.getGlovoPharmacyStatus.REQUEST]: (state) => {
    state.glovoEnabledPharmacyStatus.loading = true;
    state.glovoEnabledPharmacyStatus.error = null;
  },

  [actions.getGlovoPharmacyStatus.SUCCESS]: (state, action) => {
    state.glovoEnabledPharmacyStatus.loading = false;
    state.glovoEnabledPharmacyStatus.data.status =
      action.payload.status === 'open';
    if (action.payload.until) {
      state.glovoEnabledPharmacyStatus.data.until = action.payload.until;
    }
  },

  [actions.getGlovoPharmacyStatus.ERROR]: (state, action) => {
    state.glovoEnabledPharmacyStatus.loading = false;
    state.glovoEnabledPharmacyStatus.error =
      action.payload.response.data.message;
  },
});

const glovoEnabledPharmaccy = (state: AppState) =>
  state.settingsPagePharmacyReducer.glovoEnabledPharmacyStatus.data;
const glovoEnabledPharmaccyError = (state: AppState) =>
  state.settingsPagePharmacyReducer.glovoEnabledPharmacyStatus.error;

const selectors = {
  glovoEnabledPharmaccy,
  glovoEnabledPharmaccyError,
};

export { selectors };
export default reducer;
